import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-search-order-preview',
    templateUrl: './search-order-preview.component.html',
    styleUrls: ['./search-order-preview.component.scss']
})
export class SearchOrderPreviewComponent implements OnInit {
    @Input()
    order: any
    constructor() {}

    ngOnInit(): void {
    }

}
